import React, { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const EmployeesMain = lazy(() => import('../employees/EmployeesMain'));
const EmployeeRosters = lazy(() => import('../employees/EmployeeRosters'));
const EmployeeDoctors = lazy(
  () => import('../employees/Doctors/EmployeeDoctors')
);
const EmployeeTranslators = lazy(
  () => import('../employees/Translators/EmployeeTranslators')
);
const EmployeePermissionRequests = lazy(
  () => import('../employees/EmployeePermissionRequests')
);
const EmployeePermissionRequest = lazy(
  () => import('../employees/EmployeePermissionRequest')
);

export default [
  {
    id: NavConfig.groupConfigs.EMPLOYEES.id,
    path: NavConfig.groupConfigs.EMPLOYEES.to,
    element: (
      <EmployeesMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </EmployeesMain>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={NavConfig.linkConfigs.EMP_ROSTERS.to} />,
      },
      {
        id: NavConfig.linkConfigs.EMP_ROSTERS.id,
        path: NavConfig.linkConfigs.EMP_ROSTERS.to,
        element: <EmployeeRosters />,
      },
      {
        id: NavConfig.linkConfigs.EMP_DOCTORS.id,
        path: NavConfig.linkConfigs.EMP_DOCTORS.to,
        element: <EmployeeDoctors />,
      },
      {
        id: NavConfig.linkConfigs.EMP_TRANSLATORS.id,
        path: NavConfig.linkConfigs.EMP_TRANSLATORS.to,
        element: <EmployeeTranslators />,
      },
      {
        id: NavConfig.linkConfigs.EMP_PERMISSION_REQUESTS.id,
        path: NavConfig.linkConfigs.EMP_PERMISSION_REQUESTS.to,
        element: <EmployeePermissionRequests />,
      },
      {
        id: NavConfig.linkConfigs.EMP_PERMISSION_REQUEST.id,
        path: NavConfig.linkConfigs.EMP_PERMISSION_REQUEST.to,
        element: <EmployeePermissionRequest />,
      },
    ],
  },
];
